import React from "react";
import { Alert, AlertTitle } from "@mui/material";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
  root: {
    display: "flex",
    alignItems: "flex-start",
    border: "1px solid #FF0A002B",
    borderRadius: theme.spacing(1),
    backgroundColor: "#FEF3F3",
    padding: theme.spacing(1),
    textAlign: "left",
  },
}));

const DBCrashedError = () => {
  const { classes } = useStyles();

  return (
    <Alert severity="error" className={classes.root}>
      <AlertTitle>
        Database Crashed
      </AlertTitle>
      Please use the Restore Database option to restore the stable database version.
    </Alert>
  );
};
export default DBCrashedError;
